import { ToastContainer } from "react-toastify";
import { ColorPalette } from "./util/const";
import { RColumn, RRow, Space, SpaceHorizontal } from "./comps/otherCOmps";
import { useState } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import { Icon } from "@tremor/react";
import {
  Ri4kFill,
  RiArrowLeftLine,
  RiHistoryLine,
  RiLineChartLine,
  RiSettings2Line,
  RiTrophyLine,
} from "@remixicon/react";

import ChatGames from "./chatgames/page";
import BestChats from "./chatgames/bestChats";
import LatestBetsChatGames from "./chatgames/latestBets";
import SettingsPage from "./settings/settingsPage";

export default function PagesContainer() {
  const [isMenuOpen, setIsMenuOpen] = useState(true);

  function SingleBtn({ tit, href, icon = Ri4kFill }) {
    return (
      <NavLink
        style={{ width: "100%" }}
        to={href}
        className={({ isActive }) =>
          isActive ? "active-link-sidebar" : "inactive-link-sidebar"
        }
      >
        <RRow width={"100%"} horizontalAlign="start">
          <Icon icon={icon} variant="simple" color="black" />
          {isMenuOpen && <SpaceHorizontal />}
          {isMenuOpen ? tit : null}
        </RRow>
      </NavLink>
    );
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
      <div
        style={{
          overflowY: "auto",
          zIndex: 10,
          position: "fixed",
          width: isMenuOpen ? "260px" : "80px",
          height: "100vh",
          backgroundColor: ColorPalette.bgColorLight,
          top: 0,
          left: 0,
        }}
        className="animate"
      >
        <Space height="12px" />
        <RColumn
          verticalAlignment="space-between"
          height={"95%"}
          padding={isMenuOpen ? "0px 22px" : null}
        >
          <RColumn
            width={"100%"}
            horizontalAlign={isMenuOpen ? "start" : "center"}
            verticalAlignment="start"
          >
            <RColumn>
              <div style={{ height: "100px" }}>
                {!isMenuOpen && <Space height="18px" />}
                <img
                  src={"/images/logo_low.jpeg"}
                  width={isMenuOpen ? "70px" : "32px"}
                  alt=""
                />
              </div>
              <SingleBtn tit={"Dashboard"} href={"/"} icon={RiLineChartLine} />
              <SingleBtn
                tit={"Best chats"}
                href={"/chatgames/bestchat"}
                icon={RiTrophyLine}
              />
              <SingleBtn
                tit={"Last bets"}
                href={"/chatgames/latest"}
                icon={RiHistoryLine}
              />
            </RColumn>
          </RColumn>

          <RRow
            width={"100%"}
            horizontalAlign={!isMenuOpen ? "center" : "start"}
          >
            <RColumn horizontalAlign="start">
              <SingleBtn
                tit={"Settings"}
                href={"/settings"}
                icon={RiSettings2Line}
              />
              <Space />
              <div style={{ cursor: "pointer" }}>
                <RiArrowLeftLine
                  className="animate"
                  style={{ rotate: isMenuOpen ? "0deg" : "180deg" }}
                  onClick={() => setIsMenuOpen((prev) => !prev)}
                />
              </div>
            </RColumn>
          </RRow>
        </RColumn>
        <Space />
      </div>
      <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
        <div
          className="animate"
          style={{ width: isMenuOpen ? "270px" : "100px" }}
        ></div>
        <div style={{ flex: 1 }}>
          <div style={{ padding: "12px 18px" }}>
            <Routes>
              <Route path="/" element={<ChatGames />} />
              <Route exact path="/settings" element={<SettingsPage />} />
              <Route exact path="/chatgames" element={<ChatGames />} />
              <Route exact path="/chatgames/bestchat" element={<BestChats />} />
              <Route
                exact
                path="/chatgames/latest"
                element={<LatestBetsChatGames />}
              />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}
